export default "__VITE_ASSET__B3Zdr4P9__"